import type { ICategory, ICategoryRaw } from '@/entities/category/model/types/categories';
import { CATEGORIES_FETCH_ERROR } from '@/entities/category/lib/categoryMessages';
import { modifyCategories } from '@/entities/category/lib/modifyCategories';
import { logError, normalizeError } from '@/shared/lib/errors';

export const useCategoriesStore = defineStore('categories', () => {
  const { $categoriesService } = useNuxtApp();

  const categories: Ref<ICategory[]> = ref([]);
  const isLoadingCategories: Ref<boolean> = ref(false);

  const getCategories = async (): Promise<void> => {
    if (categories.value.length) return;

    isLoadingCategories.value = true;
    try {
      const { data } = await $categoriesService.getCategories<{ data: ICategoryRaw[] }>();
      categories.value = modifyCategories(data);
    } catch (error) {
      logError(normalizeError(error), { action: CATEGORIES_FETCH_ERROR });
    } finally {
      isLoadingCategories.value = false;
    }
  };

  const setCategories = (value: ICategory[]): void => {
    categories.value = value;
  };

  return {
    categories,
    isLoadingCategories,
    getCategories,
    setCategories,
  };
});
